import { Edit, MoreVertical, Receipt, Search, Trash2 } from 'lucide-react'

import { useState } from 'react'

import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { Input } from '@/components/ui/input'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table'

import { TaxRate } from '@/types/taxes'

export const TaxRates = () => {
  const [searchTerm, setSearchTerm] = useState('')

  // Mock data
  const rates: TaxRate[] = [
    {
      id: '1',
      name: 'Standard Rate (NY)',
      rate: 8.875,
      country: 'US',
      state: 'NY',
      taxClass: 'Standard',
      priority: 1,
      compound: false,
      enabled: true,
      createdAt: new Date(),
    },
    {
      id: '2',
      name: 'Reduced Rate (Food)',
      rate: 4.0,
      country: 'US',
      state: 'NY',
      taxClass: 'Reduced',
      priority: 1,
      compound: false,
      enabled: true,
      createdAt: new Date(),
    },
    {
      id: '3',
      name: 'California State Tax',
      rate: 7.25,
      country: 'US',
      state: 'CA',
      taxClass: 'Standard',
      priority: 1,
      compound: false,
      enabled: true,
      createdAt: new Date(),
    },
    {
      id: '4',
      name: 'VAT (UK)',
      rate: 20.0,
      country: 'GB',
      taxClass: 'Standard',
      priority: 1,
      compound: false,
      enabled: true,
      createdAt: new Date(),
    },
  ]

  const filteredRates = rates.filter((rate) =>
    rate.name.toLowerCase().includes(searchTerm.toLowerCase())
  )

  return (
    <div>
      <div className="border-t border-border-subtle p-2">
        <div className="relative w-full sm:w-64">
          <Search className="absolute left-2.5 top-1/2 size-4 -translate-y-1/2 text-muted-foreground" />
          <Input
            placeholder="Search tax rates"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="pl-8"
          />
        </div>
      </div>

      <div className="border-t border-border-subtle">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Tax</TableHead>
              <TableHead className="text-right">Rate</TableHead>
              <TableHead>Region</TableHead>
              <TableHead>Class</TableHead>
              <TableHead>Priority</TableHead>
              <TableHead>Status</TableHead>
              <TableHead className="w-12"><span className="sr-only">Actions</span></TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {filteredRates.length === 0 ? (
              <TableRow>
                <TableCell colSpan={7} className="py-8 text-center text-text-2">
                  <Receipt className="mx-auto mb-2 size-8 text-muted-foreground" />
                  <p className="text-sm">No tax rates found</p>
                </TableCell>
              </TableRow>
            ) : (
              filteredRates.map((rate) => (
                <TableRow key={rate.id}>
                  <TableCell className="font-medium text-ink">{rate.name}</TableCell>
                  <TableCell className="text-right tabular-nums">{rate.rate}%</TableCell>
                  <TableCell>
                    {rate.state ? `${rate.state}, ${rate.country}` : rate.country}
                  </TableCell>
                  <TableCell>{rate.taxClass}</TableCell>
                  <TableCell className="tabular-nums">{rate.priority}</TableCell>
                  <TableCell>
                    <Badge tone={rate.enabled ? 'success' : 'soft'}>
                      {rate.enabled ? 'Active' : 'Inactive'}
                    </Badge>
                  </TableCell>
                  <TableCell>
                    <DropdownMenu>
                      <DropdownMenuTrigger asChild>
                        <Button variant="ghost" size="icon" aria-label="Actions">
                          <MoreVertical className="size-4" />
                        </Button>
                      </DropdownMenuTrigger>
                      <DropdownMenuContent align="end">
                        <DropdownMenuItem>
                          <Edit className="size-4" />
                          Edit
                        </DropdownMenuItem>
                        <DropdownMenuItem className="text-destructive">
                          <Trash2 className="size-4" />
                          Delete
                        </DropdownMenuItem>
                      </DropdownMenuContent>
                    </DropdownMenu>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </div>
    </div>
  )
}
